<template>
  <v-main>
    <QueuesList />
    <router-view />
    <QueueAgents />
  </v-main>
</template>

<script>
import QueuesList from '@/components/queues/list'
import QueueAgents from '@/components/queues/agents'
export default {
  name: 'view-queues',
  components: { QueuesList, QueueAgents }
}
</script>

<style scoped>
</style>
